import { forwardRef } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import ValueProposition from "@/components/ValueProposition";
import DisplaysShowcase from "@/components/DisplaysShowcase";
import FeaturesSection from "@/components/FeaturesSection";
import SocialProof from "@/components/SocialProof";
import TargetAudience from "@/components/TargetAudience";
import FaqSection from "@/components/FaqSection";
import ContactFooter from "@/components/ContactFooter";
import SEOHead from "@/components/SEOHead";

const organizationLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Index Rerum",
  url: "https://indexrerum.com",
  logo: "https://indexrerum.com/favicon.png",
  description:
    "Software web para gestão de património, inventário museológico e arquivos.",
  founder: { "@type": "Organization", name: "EVOKE IT" },
};

const websiteLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Index Rerum",
  url: "https://indexrerum.com",
};

const faqLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "É necessário instalar software?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Não. O acesso é feito inteiramente via browser. Basta uma ligação à internet.",
      },
    },
    {
      "@type": "Question",
      name: "Posso importar dados existentes?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Sim. Suportamos importação massiva através de ficheiros Excel e XML.",
      },
    },
    {
      "@type": "Question",
      name: "Como funciona a segurança?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Utilizamos permissões Unix-style combinadas com RBAC, garantindo que cada utilizador vê apenas o que deve.",
      },
    },
    {
      "@type": "Question",
      name: "O sistema é responsivo?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Sim, a interface adapta-se automaticamente a tablets e dispositivos móveis.",
      },
    },
    {
      "@type": "Question",
      name: "O número de utilizadores é limitado?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Não. O Index Rerum permite a criação de qualquer número de utilizadores com login sem repercussão no preço.",
      },
    },
    {
      "@type": "Question",
      name: "Existe limite para o número/tipo de fichas?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Não. Qualquer número/tipo de registos é possível, incluindo áudio e vídeo.",
      },
    },
    {
      "@type": "Question",
      name: "O que é possível inventariar?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Tudo. Respeitamos a legislação nacional e as normas internacionais para todo o património tangível e intangível.",
      },
    },
  ],
};

const Index = forwardRef<HTMLDivElement>((_, ref) => {
  return (
    <div ref={ref} className="min-h-screen">
      <SEOHead
        canonicalPath="/"
        jsonLd={[organizationLd, websiteLd, faqLd]}
      />
      <Navbar />
      <HeroSection />
      <ValueProposition />
      <DisplaysShowcase />
      <FeaturesSection />
      <SocialProof />
      <TargetAudience />
      <FaqSection />
      <ContactFooter />
    </div>
  );
});

Index.displayName = "Index";

export default Index;
